import type { ReadonlyDeep } from 'type-fest';

import { DocumentInput } from '@e-socna/data-layer';

import { codingConfigForm2ApiMapper } from '../../../forms/CodingConfig/mappers/coding-config.form2api.mapper';
import { pruneInput } from '../../../utils/prune-input.util';

import type { DocumentEditorCmp_Document } from '../fragments/document.fragment';

import { recursiveSectionForm2ApiMapper } from './recursive-section.form2api.mapper';

export function documentForm2ApiMapper(
  document: ReadonlyDeep<DocumentEditorCmp_Document>,
) {
  const documentInput = pruneInput(document, DocumentInput);

  return {
    ...documentInput,
    virtualRoot: recursiveSectionForm2ApiMapper(document.virtualRoot),
    codingConfig: codingConfigForm2ApiMapper(document.codingConfig),
  };
}
